import { CardHeader, Grid, Typography, generateUtilityClasses } from '@mui/material'
import { styled } from '@mui/system'
import React, { useEffect } from 'react'
import AddressField from '../../../../../../ui/AddressField'
import { TextField } from '../../../../../../ui'
import DropdownFieldSearch from '../../../../../../ui/DropdownFieldSearch'
import { useSelector } from 'react-redux'
import { useForm } from 'react-final-form'
import { getStates } from '../../../../../../redux/slices/userDropdownSlice'
import { useLazyGetInfoByZipCodeQuery } from '../../../../../../services'

const classes = generateUtilityClasses('Grid', ['root', 'row', 'optionalText'])

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  [`& .${classes.optionalText}`]: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 400,
    Size: '0.8750em',
    fontStyle: 'italic',
    lineHeight: '1.1875em',
    marginLeft: theme.spacing(1),
  },
}))

interface Props {}

const PayFormDetails = ({}: Props) => {
  const states = useSelector(getStates)
  const form = useForm()
  const addressValue = form.getFieldState('Address1')?.value || ''
  const [getInfoByZipCode, { data: infoByZipCodeData }] = useLazyGetInfoByZipCodeQuery()

  useEffect(() => {
    if (addressValue) {
      const { street, city, state, zip } = addressValue
      if (zip) {
        getInfoByZipCode({ zipCode: zip?.toString() as string })
      }

      // Only update the form fields if the parsed values are not null
      if (street) form.change('Address1', street)
      if (city) form.change('City', city)
      if (state) form.change('State', state)
      if (zip) form.change('PostalCode', zip)
      if (infoByZipCodeData) {
        form.change('County', infoByZipCodeData?.County)
      }
    }
  }, [addressValue, form, infoByZipCodeData])

  return (
    <>
      <CardHeader title='Pay To The Order Of' />
      <Grid container spacing={2} p={3}>
        <Grid item xs={12} sm={6}>
          <TextField name='Attention' label='Attention' fullWidth autoComplete='off' />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField name='PayeeName' label='Payee Name' fullWidth autoComplete='off' />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AddressField name='Address1' label='Address Line 1' fullWidth autoComplete='off' />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField name='Address2' label='Address Line 2' fullWidth autoComplete='off' />
        </Grid>
        <Grid item xs={8} sm={4}>
          <TextField name='City' label='City' fullWidth autoComplete='off' />
        </Grid>
        <Grid item xs={4} sm={2}>
          <DropdownFieldSearch name='State' label='State' options={states} optionKey='State' optionValue='State' autoComplete='off' />
        </Grid>
        <Grid item xs={8} sm={4}>
          <TextField number name='PostalCode' label='Zip Code' fullWidth autoComplete='off' />
        </Grid>
        <Grid item xs={4} sm={2}>
          <TextField name='County' label='County' fullWidth autoComplete='off' />
        </Grid>
      </Grid>
    </>
  )
}

export default PayFormDetails
